import ajax from './ajax.js';
import cityCode from '../resources/js/cityCode.js';
// let rootUri = 'http://localhost:8070/api/';
let rootUri = '/fsgo/';
var osg = {
  rootUri: rootUri,
  /**
   * 获取传入页面参数
   *
   * @param {Object} key
   */
  param: function(key) {
    var p = this.paramObj();
    if (p) return p[key];
    else return null;
  },
  /**
   * 获取传入页面参数对象
   */
  paramObj: function() {
    if (!window.$this) return;
    return Object.assign(window.$this.$route.params, window.$this.$route.query);
  },
  /**
   * http状态码
   */
  httpStatusCode: '',
  /**
   * 网络连接api
   *
   * @param {Object} url 网络请求的url，'~'开头则保留原始url
   * @param {Object} data
   * @param {Object} callback
   * @param {Object} options
   * 		-method 		GET or POST
   * 		-noload 		是否不显示加载中
   */
  ajax: function(url, data, callback, options) {
    options = options || {};
    let XAuthToken = JSON.stringify(sessionStorage.getItem('token'));
    var method = options.method,
      noload = options.noload,
      header = options.header || { 'X-Auth-Token': XAuthToken.slice(3, -3) },
      responseType = options.responseType;
    method = method || 'POST';
    data = data || {};
    if (url.indexOf('https://restapi.amap.com/') != -1) delete header['X-Auth-Token'];
    if (!noload) {
      this.loading();
    }
    var m = 'GET' == method ? ajax.ajax.get : ajax.ajax.post;
    if (!url.startsWith('~')) {
      if (url.startsWith('/')) url = url.substring(1);
      url = rootUri + url;
    } else {
      url = url.substring(1);
    }
    m(
      url,
      data,
      header,
      responseType,
      res => {
        // 企微应用页面，不跳转PC首页，单独处理逻辑。
        if (res == 'restart') {
          if (options.fail) options.fail(res);
          return;
        }

        // 更新cookie过期时间，从此刻开始两小时后过期
        // 轮询调用不更新cookie过期时间，防止页面无操作停留一直不过期。  url.indexOf('chatMessage/getNewMessageCount') == -1 &&
        if (window.$this && url.indexOf('notification/query') == -1) {
          let token = window.$this.$util.cookie.get(window.$this.$util.cookieRelative.token);
          if (token) {
            window.$this.$util.cookie.set(
              window.$this.$util.cookieRelative.token,
              token,
              window.$this.$util.cookieRelative.tokenExpires
            );
          }
        }
        if (!noload) this.unload();
        if (res.message && !res.success) {
          if (res.data && res.data.code == 11001) {
            osg.confirm(
              '当前数据已过期，如需保存请在新打开的页面填写',
              () => {
                osg.open(null, {}, '_blank', window.$this.$route.path);
              },
              '打开新页面',
              '取消'
            );
          } else if (res.data && res.data.event == 'WinnerLookBusy') {
            // 解绑中继号
            this.confirm(
              res.message,
              () => {
                this.unBindPrivateNumber();
              },
              '解绑'
            );
          } else {
            this.alert(res.message);
          }
          if (options.fail) options.fail(res);
        } else if (callback) callback(res);
      },
      res => {
        if (!noload) this.unload();
        let path = '';
        if (window.$this) {
          path = window.$this.$route.path;
        } else if (window.$vue) {
          path = window.$vue.$route.path;
        }
        if (res.message.indexOf('401') != -1 && path != '/') {
          if (osg.httpStatusCode != '401') {
            osg.httpStatusCode = '401';
            osg.confirm(
              '您没有访问权限或权限已失效，请重新登录！',
              () => {
                sessionStorage.clear();
                if (window) {
                  if (window.$this) {
                    window.$this.$router.push({ path: '/' });
                  } else if (window.$vue) {
                    window.$vue.$router.push({ path: '/' });
                  }
                }
              },
              '重新登录'
            );
          }
        } else {
          // osg.toast('发送请求失败，请稍后重试！', 'error');
        }
      }
    );
  },
  /**
   * 打开新窗口（路由到新窗口）
   *
   * @param {Object} url router.js中配置的name
   * @param {Object} extras 打开窗口传参
   */
  open: function(url, extras, target, path) {
    extras = extras || {};
    if (!window.$this) return;
    if (target == '_blank') {
      let routeUrl;
      if (path) {
        routeUrl = window.$this.$router.resolve({
          path
        });
      } else {
        routeUrl = window.$this.$router.resolve({
          name: url,
          query: extras
        });
      }
      console.log('open', routeUrl.href);
      window.open(routeUrl.href, '_blank');
    } else {
      window.$this.$router.push({
        name: url,
        query: extras
      });
    }
  },
  /**
   * toast消息组件
   *
   * @param {Object} msg
   */
  toast: function(msg, type) {
    if (!window.$this) return;
    if (type) {
      window.$this.$message({
        message: msg,
        type: type
      });
    } else {
      window.$this.$message({ message: msg, type: 'success' });
    }
  },
  /**
   * alert提示框组件
   *
   * @param {Object} msg
   * @param {Object} callback
   */
  alert: function(msg, callback, title, dangerouslyUseHTMLString) {
    if (!window.$this) return;
    window.$this.$alert(msg, title || '提示', {
      confirmButtonText: '确定',
      dangerouslyUseHTMLString: dangerouslyUseHTMLString,
      callback: () => {
        if (callback) callback();
      }
    });
  },
  /**
   * confirm确认框组件
   *
   * @param {Object} msg
   * @param {Object} callback
   */
  confirm: function(msg, callback, confirmButtonText, cancelButtonText) {
    if (!window.$this) return;
    window.$this
      .$confirm(msg, '确认', {
        confirmButtonText: confirmButtonText || '确定',
        cancelButtonText: cancelButtonText || '取消',
        type: 'warning'
      })
      .then(() => {
        if (callback) callback();
      })
      .catch(() => {
        // 取消
      });
  },
  /**
   * 显示加载中
   *
   * @param {Object} msg
   */
  loading: function(msg) {
    if (!msg) msg = '处理中...';
    if (!window.$this) return;
    let ld = window.$this.$loading({
      lock: true,
      text: msg,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    if (this.loadingObj) this.loadingObj.close();
    this.loadingObj = ld;
  },
  /**
   * 隐藏加载中
   */
  unload: function() {
    if (this.loadingObj) this.loadingObj.close();
    delete this.loadingObj;
  },
  validate: function(formData, that) {
    formData = formData || 'formData';
    var pass = false;
    if (that) window.$this = that;
    if (!window.$this) return;
    if (window.$this.$refs[formData]) {
      if (window.$this.$refs[formData].validate) {
        window.$this.$refs[formData].validate(valid => {
          let formObj = window.$this[formData];
          if (formObj) {
            let fields = window.$this.extFields;
            if (fields) {
              for (let field of fields) {
                try {
                  if (field.frontEndConfig.verify) {
                    // 需要正则校验
                    if (
                      (field.preset ? formObj[field.name] : formObj.exts[field.name]) &&
                      field.frontEndConfig.verify
                    ) {
                      if (!this.verify(field, formData)) {
                        osg.alert(field.nameDisp + '格式错误');
                        return;
                      }
                    }
                  }
                } catch (error) {
                  console.log(field, field.name, field.nameDisp);
                }
              }
            }
          }
          if (valid) pass = true;
        });
      } else if (
        window.$this.$refs[formData] &&
        window.$this.$refs[formData].$refs['formData'].validate
      ) {
        window.$this.$refs[formData].$refs['formData'].validate(valid => {
          let formObj = window.$this[formData];
          if (formObj) {
            let fields = window.$this.extFields;
            if (fields) {
              for (let field of fields) {
                try {
                  if (field.frontEndConfig.verify) {
                    // 需要正则校验
                    if (
                      (field.preset ? formObj[field.name] : formObj.exts[field.name]) &&
                      field.frontEndConfig.verify
                    ) {
                      if (!this.verify(field, formData)) {
                        osg.alert(field.nameDisp + '格式错误');
                        return;
                      }
                    }
                  }
                } catch (error) {
                  console.log(field, field.name, field.nameDisp);
                }
              }
            }
          }
          if (valid) pass = true;
        });
      }
    } else if (window.$this.$refs['form'] && window.$this.$refs['form'].$refs['formData']) {
      window.$this.$refs['form'].$refs['formData'].validate(valid => {
        //判断正则校验字段
        let formObj = window.$this[formData];
        if (formObj) {
          let fields = window.$this.extFields;
          if (fields) {
            for (let field of fields) {
              try {
                if (field.frontEndConfig.verify) {
                  // 需要正则校验
                  if (
                    (field.preset ? formObj[field.name] : formObj.exts[field.name]) &&
                    field.frontEndConfig.verify
                  ) {
                    if (!this.verify(field, formData)) {
                      osg.alert(field.nameDisp + '格式错误');
                      return;
                    }
                  }
                }
              } catch (error) {
                console.log(field);
              }
            }
          }
        }

        if (valid) pass = true;
      });
    }
    return pass;
  },
  // 正则校验
  verify(extField, formData) {
    //多个正则表达式的对象
    let regexpObj = extField.frontEndConfig.regexpObj;
    if (!regexpObj) return false;
    //根据某字段值选择不同正则表达式
    let verifyField = extField.frontEndConfig.verifyField;
    let formObj = window.$this[formData];
    if (verifyField) {
      let key = extField.preset ? formObj[verifyField] : formObj.exts[verifyField];
      if (key) {
        let regexp = new RegExp(regexpObj[key]);
        if (regexp) {
          if (regexp.test(extField.preset ? formObj[extField.name] : formObj.exts[extField.name])) {
            return true;
          }
        }
      }
    } else {
      // 默认正则表达式，无需根据其他字段值选择不同正则表达式
      let regexp = new RegExp(regexpObj.regexp);
      if (regexp) {
        if (regexp.test(extField.preset ? formObj[extField.name] : formObj.exts[extField.name])) {
          return true;
        }
      }
    }
    return false;
  },
  //保存的分页和搜索条件
  setFpi(params) {
    params = params || {};
    let fpi = {
      colName: window.$this.$route.fullPath.substring(1),
      page: params.page,
      rows: params.rows,
      searchValue: window.$this.searchValue,
      searchDate: window.$this.searchDate,
      searchDateValue: window.$this.searchDateValue
    };
    if (fpi.colName == 'ProductInventoryItems') {
      fpi.searchObj = window.$this.searchObj;
    }
    if (fpi.colName.indexOf('Contracts') != -1) {
      fpi.searchDateValue = window.$this.searchDateValue;
      fpi.searchExaminStatus = window.$this.searchExaminStatus; //审核状态
      fpi.searchsettleType = window.$this.searchsettleType; //结算状态
      fpi.searchStateValue = window.$this.searchStateValue; //合同状态
    }
    if (fpi.colName.indexOf('OrgUser') != -1) {
      fpi.searchRoleIds = window.$this.searchRoleIds;
    }
    if (fpi.colName.indexOf('SLAs') != -1) {
      fpi.currentWorkflowDefId = window.$this.currentWorkflowDefId;
    }
    if (fpi.colName == 'ServiceAppointments' || fpi.colName == 'WorkOrders') {
      fpi.orderState = window.$this.orderState;
    } else if (fpi.colName.indexOf('Flows?') != -1) {
      fpi.orderState = window.$this.state;
    }
    if (fpi.colName == 'NeighborhoodStat') {
      fpi.page = window.$this.fpi.page;
      fpi.rows = window.$this.fpi.rows;
      fpi.city = window.$this.city;
      fpi.district = window.$this.district;
      fpi.subdistrict = window.$this.subdistrict;
      fpi.districts = window.$this.districts;
      fpi.subdistrictGroup = window.$this.subdistrictGroup;
      fpi.leakagesite = window.$this.leakagesite;
      fpi.dateRange = window.$this.dateRange;
      fpi.sortField = window.$this.sortField;
      fpi.sortOrder = window.$this.sortOrder;
    }

    //保存分页和搜索条件
    sessionStorage['fpi'] = JSON.stringify(fpi);
  },
  // 存最近打开的行的id，返回列表时高亮展示
  setLastRowId(colName, id) {
    if (sessionStorage['fpi']) {
      let fpi = JSON.parse(sessionStorage['fpi']);
      if (fpi.colName == colName || fpi.colName.startsWith(colName)) {
        fpi.lastRowId = id;
      }
      sessionStorage['fpi'] = JSON.stringify(fpi);
    }
  },
  lastRowClassName({ row }) {
    if (
      window.$this.lastRowId &&
      (row.data ? row.data._id == window.$this.lastRowId : row._id == window.$this.lastRowId)
    ) {
      return 'speak-row';
    }
    return '';
  },
  //获取保存的分页和搜索条件
  getFpi() {
    //默认值 防止同一路由页面切换data未更新问题
    window.$this.fpi = window.$this.fpi || {};
    window.$this.fpi.page = '';
    window.$this.fpi.rows = '';
    window.$this.searchValue = '';
    window.$this.searchDate = [];
    window.$this.searchDateValue = [];
    window.$this.searchRoleIds = []; //人员角色
    window.$this.orderState = window.$this.orderState || '';
    window.$this.state = window.$this.state || '';

    this.searchValue = '';
    if (sessionStorage['fpi']) {
      let fpi = JSON.parse(sessionStorage['fpi']);
      if (fpi.colName == window.$this.$route.fullPath.substring(1)) {
        window.$this.fpi = window.$this.fpi || {};
        window.$this.fpi.page = fpi.page;
        window.$this.fpi.rows = fpi.rows;
        window.$this.searchValue = fpi.searchValue;
        window.$this.searchDate = fpi.searchDate;
        window.$this.searchDateValue = fpi.searchDateValue;
        window.$this.lastRowId = fpi.lastRowId;
        if (fpi.colName == 'ProductInventoryItems') {
          window.$this.searchObj = fpi.searchObj;
        }
        if (fpi.colName.indexOf('Contracts') != -1) {
          window.$this.searchExaminStatus = fpi.searchExaminStatus; //审核状态
          window.$this.searchsettleType = fpi.searchsettleType; //结算状态
          window.$this.searchStateValue = fpi.searchStateValue; //合同状态
        }
        if (fpi.colName.indexOf('OrgUser') != -1) {
          window.$this.searchRoleIds = fpi.searchRoleIds; //人员角色
        }
        if (fpi.colName.indexOf('SLAs') != -1) {
          window.$this.currentWorkflowDefId = fpi.currentWorkflowDefId; //人员角色
        }
        if (fpi.colName.indexOf('Flows?') != -1) {
          window.$this.state = fpi.orderState;
        } else if (fpi.colName == 'ServiceAppointments' || fpi.colName == 'WorkOrders') {
          window.$this.orderState = fpi.orderState;
        }
        if (fpi.colName.indexOf('NeighborhoodStat') != -1) {
          window.$this.city = fpi.city;
          window.$this.district = fpi.district;
          window.$this.subdistrict = fpi.subdistrict;
          window.$this.districts = fpi.districts;
          window.$this.subdistrictGroup = fpi.subdistrictGroup;
          window.$this.leakagesite = fpi.leakagesite;
          window.$this.dateRange = fpi.dateRange;
          window.$this.sortField = fpi.sortField;
          window.$this.sortOrder = fpi.sortOrder;
        }
      }
    }
  },
  /**
   * 获取扩展字段
   */
  getFields(colName, callback, that, extFields, extId, tenantId, params, optsName) {
    // let currentComponent = that || window.$this; //临时变量
    window.$this = that || window.$this;
    extFields = extFields || 'extFields';
    let obj = {
      colName,
      extId,
      _all: '1',
      'is:state|integer#and': 1,
      sortField: 'order',
      sortOrder: 'asc',
      tenantId
    };
    obj = Object.assign(obj, params || {});
    osg.ajax(
      'biz/extField/query.do',
      obj,
      res => {
        // 赋值参照-fields
        if (extFields && extFields.indexOf('.') != -1) {
          window.$this.$set(
            window.$this[extFields.split('.')[0]],
            extFields.split('.')[1],
            res.data
          );
          // window.$this[extFields.split('.')[0]][extFields.split('.')[1]] = res.data;
        } else {
          // currentComponent[extFields] = res.data;
          window.$this[extFields] = res.data;
        }

        // 赋值参照-requestOptions 默认值
        if (optsName) {
          // 例如参照-表格字段
          if (optsName.indexOf('.') != -1) {
            let key = optsName.split('.')[0];
            let value = optsName.split('.')[1];
            window.$this[key][value] = window.$this[key][value] || {};
          } else {
            window.$this[optsName] = window.$this[optsName] || {};
          }
        } else {
          window.$this.options = window.$this.options || {};
        }
        // let fieldsObj = {};
        let scriptIds = [];
        for (let item of res.data) {
          // 解析frontEndConfig
          if (window.$this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }

          // 整理字段关联的脚本id
          if (window.$this.$util.isJson(item.calculateConfig)) {
            item.calculateConfig = JSON.parse(item.calculateConfig);
            if (item.calculateConfig.scriptId) {
              scriptIds.push(item.calculateConfig.scriptId);
            }
          } else {
            item.calculateConfig = {};
          }

          // TODO:贝壳返厂清单
          if (item.frontEndConfig.optionField) {
            this.getProductOption(item.valueOption || item.name);
          }

          // 整理需要请求的字典
          if (
            item.valueOption &&
            item.type != 'bizSelect' &&
            item.type != 'request' &&
            !item.frontEndConfig.noRequest
          ) {
            if (item.type == 'cascade') {
              if (optsName) {
                if (optsName.indexOf('.') != -1) {
                  let key = optsName.split('.')[0];
                  let value = optsName.split('.')[1];
                  window.$this[key][value]['cascadeCode_' + item.valueOption] = {
                    codeId: item.valueOption,
                    frontEndConfig: item.frontEndConfig
                  };
                } else {
                  window.$this[optsName]['cascadeCode_' + item.valueOption] = {
                    codeId: item.valueOption,
                    frontEndConfig: item.frontEndConfig
                  };
                }
              } else {
                window.$this.options['cascadeCode_' + item.valueOption] = {
                  codeId: item.valueOption,
                  frontEndConfig: item.frontEndConfig
                };
              }
            } else {
              if (optsName) {
                if (optsName.indexOf('.') != -1) {
                  let key = optsName.split('.')[0];
                  let value = optsName.split('.')[1];
                  window.$this[key][value]['codecfg_' + item.valueOption] = {
                    codeId: item.valueOption,
                    frontEndConfig: item.frontEndConfig
                  };
                } else {
                  window.$this[optsName]['codecfg_' + item.valueOption] = {
                    codeId: item.valueOption,
                    frontEndConfig: item.frontEndConfig
                  };
                }
              } else {
                window.$this.options['codecfg_' + item.valueOption] = {
                  codeId: item.valueOption,
                  frontEndConfig: item.frontEndConfig
                };
              }
            }
          }
          // 手机字段支持添加多个联系人，请求联系人关系字典表
          if (item.frontEndConfig.creatable) {
            if (optsName) {
              if (optsName.indexOf('.') != -1) {
                let key = optsName.split('.')[0];
                let value = optsName.split('.')[1];
                window.$this[key][value]['codecfg_contactRelation'] = {
                  codeId: 'contactRelation',
                  frontEndConfig: item.frontEndConfig
                };
              } else {
                window.$this[optsName]['codecfg_contactRelation'] = {
                  codeId: 'contactRelation',
                  frontEndConfig: item.frontEndConfig
                };
              }
            } else {
              window.$this.options.codecfg_contactRelation = {
                codeId: 'contactRelation',
                frontEndConfig: item.frontEndConfig
              };
            }
          }
          // 列不固定时删除fixed字段，解决el-table-column组件fixed为空字符串依然固定在左侧的问题
          if (!item.fixed) {
            delete item.fixed;
          }
          // 属性变更记录反显 getHistory接口会处理,避免其他getFields接口更新掉fieldsObj
          // if (item.showList && item.showList.indexOf('6') != -1) {
          //   item.label = item.nameDisp;
          //   item.value = item.name;
          //   fieldsObj[item.name] = item;
          // }
          // 查询业务对象/参照
          // focus触发 不提前请求
          if (
            (item.type == 'bizSelect' &&
              (!item.frontEndConfig.focus || item.frontEndConfig.request)) ||
            item.type == 'request'
          ) {
            let formData = window.$this.formData || { exts: {} };

            // 处理参数中的变量
            let params = item.frontEndConfig.params || {};
            let obj = {};
            for (let key in params) {
              let val = params[key];
              if (!val && val != 0) continue;
              if (String(val).startsWith('$')) {
                obj[key] = formData[val.substring(1)];
              } else if (String(val).startsWith('#')) {
                obj[key] = null;
              }
            }

            // 请求数据作为选项
            if (item.frontEndConfig.url) {
              osg.ajax(
                item.frontEndConfig.url,
                Object.assign({}, params, obj),
                res => {
                  if (item.frontEndConfig.url.indexOf('org/query.do') != -1) {
                    res.data.orgList.map(obj => {
                      obj.label =
                        item.frontEndConfig.label.indexOf('.') != -1
                          ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                              obj[item.frontEndConfig.label.split('.')[0]][
                                item.frontEndConfig.label.split('.')[1]
                              ]) ||
                            obj.name
                          : obj[item.frontEndConfig.label] || obj.name;
                      obj.value =
                        item.frontEndConfig.value.indexOf('.') != -1
                          ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                              obj[item.frontEndConfig.value.split('.')[0]][
                                item.frontEndConfig.value.split('.')[1]
                              ]) ||
                            obj.name
                          : obj[item.frontEndConfig.value] || obj._id;
                    });
                  } else {
                    res.data.map(obj => {
                      obj.label =
                        item.frontEndConfig.label.indexOf('.') != -1
                          ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                              obj[item.frontEndConfig.label.split('.')[0]][
                                item.frontEndConfig.label.split('.')[1]
                              ]) ||
                            obj.name
                          : obj[item.frontEndConfig.label] || obj.name;
                      obj.value =
                        item.frontEndConfig.value.indexOf('.') != -1
                          ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                              obj[item.frontEndConfig.value.split('.')[0]][
                                item.frontEndConfig.value.split('.')[1]
                              ]) ||
                            obj.name
                          : obj[item.frontEndConfig.value] || obj._id;
                    });
                  }
                  if (item.type == 'request') {
                    window.$this.requestOptions[item.valueOption || item.name] = res.data;
                  } else if (optsName) {
                    if (optsName.indexOf('.') != -1) {
                      let key = optsName.split('.')[0];
                      let value = optsName.split('.')[1];
                      window.$this[key][value][item.valueOption] = res.data;
                    } else {
                      window.$this[optsName][item.valueOption] = res.data;
                    }
                  } else {
                    if (item.frontEndConfig.url.indexOf('org/query.do') != -1) {
                      window.$this.options[item.valueOption] = res.data.orgList;
                    } else {
                      window.$this.options[item.valueOption] = res.data;
                    }
                  }
                  // window.$this.refresh();
                },
                {
                  noload: true
                }
              );
            }

            // 参照-表格形式展示
            if (item.type == 'request' && item.frontEndConfig.componentType == 'table') {
              osg.getFields(
                item.frontEndConfig.colName || '',
                null,
                null,
                'options.' + (item.valueOption || item.name) + 'Fields',
                item.frontEndConfig.extId,
                null,
                null,
                'requestOptions'
              );

              // 查询表单操作按钮
              if (item.frontEndConfig.colName) {
                osg.ajax(
                  'biz/ext/queryByColName/' + item.frontEndConfig.colName + '.do',
                  {},
                  res => {
                    let actions = res.entity.exts.actions;
                    if (actions && window.$this.$util.isJson(actions)) {
                      window.$this.$set(
                        window.$this.options,
                        (item.valueOption || item.name) + 'Actions',
                        JSON.parse(actions)
                      );
                    } else {
                      window.$this.$set(
                        window.$this.options,
                        (item.valueOption || item.name) + 'Actions',
                        []
                      );
                    }
                  },
                  {
                    noload: true
                  }
                );
              }
            }
          }
          // 产品选择器 返显产品类型和单位
          if (item.type == 'quote') {
            window.$this.options.codecfg_unit = window.$this.options.codecfg_unit || {
              codeId: 'UNIT',
              frontEndConfig: item.frontEndConfig
            };
            window.$this.options.codecfg_productType = window.$this.options.codecfg_productType || {
              codeId: 'productType',
              frontEndConfig: item.frontEndConfig
            };
          }
          // 多选组件需要在formData中默认赋值空数组
          // if (item.type == 'checkbox') {
          //   if (item.preset) {
          //     window.$this.formData[item.name] = window.$this.formData[item.name] || [];
          //     window.$this.refresh = false;
          //     window.$this.$nextTick(() => {
          //       window.$this.refresh = true;
          //     });
          //   } else {
          //     window.$this.formData.exts[item.name] = window.$this.formData.exts[item.name] || [];
          //   }
          // }
        }
        // 批量请求所有用到的脚本
        if (scriptIds.length > 0) {
          let ids = [];
          scriptIds.map(id => {
            if (ids.indexOf(id) == -1) ids.push(id);
          });
          osg.ajax(
            'groovyScript/findByIds.do',
            {
              notFilterBelongTo: '1',
              notFilterOrgId: '1',
              ids: ids.join()
            },
            res => {
              let scripts = {};
              if (optsName == 'requestOptions') {
                if (window.$this.requestOptions && window.$this.requestOptions.scripts)
                  scripts = window.$this.requestOptions.scripts;
              } else {
                if (window.$this.options && window.$this.options.scripts)
                  scripts = window.$this.options.scripts;
              }
              res.data.map(item => {
                scripts[item._id] = item.scriptContent;
              });
              if (optsName == 'requestOptions') {
                window.$this.$set(window.$this.requestOptions, 'scripts', scripts);
              } else {
                window.$this.$set(window.$this.options, 'scripts', scripts);
              }
            },
            {
              noload: true
            }
          );
        }

        // 属性变更记录反显
        if (optsName) {
          // window.$this[optsName].fields = res.data;
        } else {
          window.$this.options.fields = res.data;
        }
        // window.$this.fieldsObj = fieldsObj;

        // 批量请求字典表
        osg.codeoption(
          () => {
            if (callback) callback();
          },
          null,
          optsName,
          tenantId
        );
      },
      { noload: true }
    );
  },
  // 自定义表
  customize: {
    bizType: 0,
    bizId: '',
    entity: ''
  },
  options: {
    bizType: [
      { label: '个人', value: 0 },
      { label: '组织', value: 1 },
      { label: '角色', value: 2 }
    ],
    users: [],
    orgs: [],
    roles: []
  },
  // TODO:贝壳
  getProductOption(name) {
    osg.ajax(
      'basic/product/query.do',
      {
        _all: '1',
        notFilterBelongTo: '1',
        notFilterOrgId: '1',
        'is:state|integer#and': 1,
        'is:productState|integer#and': 3, //审核通过
        'is:productType|string#and': '3', //备件
        sortField: 'createTime',
        sortOrder: 'desc'
      },
      res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        window.$this.options[name] = res.data;
      }
    );
  },
  colSetShow() {
    if (osg.customize.entity.entityID == osg.customize.entity.tenantId) {
      osg.getUsers();
    }
  },
  colWidthChange(newWidth, oldWidth, column, custListReset) {
    //custListReset 由页面传递来的自定义获取字段配置方法
    let str = column.property;
    if (str.startsWith('.')) str = str.substring(1);
    if (str.indexOf('.') != -1) {
      let arr = str.split('.');
      str = arr[arr.length - 1];
    }
    let fields = window.$this.extFields;
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].name == str) {
        fields[i].width = newWidth + 'px';
      }
    }
    osg.saveConfig(false, custListReset ? custListReset : null);
  },
  saveConfig(type, custListReset) {
    //custListReset 由页面传递来的自定义获取字段配置方法
    if (!osg.customize.bizId) {
      let msg = '';
      for (let item of osg.options.bizType) {
        if (osg.customize.bizType == item.value) {
          msg = item.label;
          break;
        }
      }
      osg.toast('请选择' + msg, 'warning');
      return;
    }
    // 自定义列
    let content = [];
    if (!type) {
      let fields = window.$this.extFields;
      fields.map(f => {
        if (f.customizeFlag) {
          content.push({ _id: f._id, width: f.width });
        }
      });
      if (content.length == 0) {
        osg.toast('请至少展示1列！', 'warning');
        return;
      }
    }

    let params = {
      name: osg.customize.name || window.$this.name,
      type: type || 0, // 0:自定义列 1:自定义过滤器 2:自定义报表
      typeSign: window.$this.name, // type是列、过滤器时 为colName
      bizType: osg.customize.bizType, // 业务类型 0:个人 1:组织 2:角色  优先级：个人 > 组织 > 角色
      bizId: osg.customize.bizId, // 业务类型对应id
      content: content
    };
    osg.ajax(
      'biz/customize/upsert.do',
      { data: JSON.stringify(params) },
      () => {
        osg.toast('保存成功');
        if (custListReset) {
          custListReset();
        } else {
          osg.listReset();
        }
      },
      {
        noload: true
      }
    );
  },
  listRefresh() {
    window.$this.refresh = false;
    window.$this.$nextTick(() => {
      if (window.$this.$refs.table) window.$this.$refs.table.doLayout();
      window.$this.refresh = true;
      window.$this.$forceUpdate();
    });
  },
  listReset() {
    osg.getFields(window.$this.name, () => {
      window.$this.$nextTick(() => {
        if (window.$this.$refs.table) window.$this.$refs.table.doLayout();
        window.$this.$forceUpdate();
      });
    });
  },
  customizeBizTypeChange(e) {
    osg.customize.bizType = e;
    osg.customize.bizId = '';
    window.$this.$forceUpdate();
    if (e == 0) {
      osg.getUsers();
    } else if (e == 1) {
      osg.getOrgs();
    } else if (e == 2) {
      osg.getRoles();
    }
  },
  getUsers(query) {
    osg.ajax(
      'user/query.do',
      {
        'is:state|integer#and': '1',
        'regex:name|string#or': query,
        'regex:phone|string#or': query,
        'regex:orgName|string#or': query,
        sortField: 'createTime',
        sortOrder: 'asc',
        page: 1,
        rows: 20
      },
      res => {
        osg.options.users = res.data;
        window.$this.$forceUpdate();
      },
      {
        noload: true
      }
    );
  },
  getOrgs() {
    osg.ajax(
      'org/query.do',
      {
        notFilterOrgId: '1'
      },
      res => {
        res.data.orgName = res.data.orgName || '全部组织';
        osg.options.orgs = [res.data];
        window.$this.$forceUpdate();
      },
      {
        noload: true
      }
    );
  },
  getRoles() {
    osg.ajax(
      'role/query.do',
      { _all: '1', 'is:state|integer#and': 1 },
      res => {
        osg.options.roles = res.data;
        window.$this.$forceUpdate();
      },
      {
        noload: true
      }
    );
  },
  /**
   * 详情页关联子扩展表单
   */
  getSubExts(colName) {
    osg.ajax(
      'biz/ext/query.do',
      {
        _all: '1',
        'in:templateType|string#and': 'TT4',
        'is:state|integer#and': 1,
        'is:parentColName|string#and': colName,
        sortField: 'createTime'
      },
      res => {
        window.$this.subExts = res.data;
        if (res.data.length > 0) {
          window.$this.activeExt = res.data[0];
          window.$this.activeTab = res.data[0].colName;
          osg.getSubFields(res.data[0].colName, res.data[0]._id);
        }
      }
    );
  },
  getSubFields(colName, extId, optsName) {
    osg.ajax(
      'biz/extField/query.do',
      {
        colName,
        _all: '1',
        'is:state|integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        window.$this.options = window.$this.options || {};
        for (let item of res.data) {
          // 解析frontEndConfig
          if (window.$this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }
          // 整理需要请求的字典
          if (item.valueOption && item.type != 'bizSelect' && item.type != 'request') {
            if (item.type == 'cascade') {
              window.$this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption,
                frontEndConfig: item.frontEndConfig
              };
            } else {
              window.$this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption,
                frontEndConfig: item.frontEndConfig
              };
            }
          }

          // 查询业务对象/参照
          if (item.type == 'bizSelect' || item.type == 'request') {
            if (!item.frontEndConfig.url) continue;
            // 处理参数中的变量
            let params = item.frontEndConfig.params;
            let formData = window.$this.formData || { exts: {} };
            let obj = {};
            for (let key in params) {
              let val = params[key];
              if (!val && val != 0) continue;
              if (String(val).startsWith('$')) {
                obj[key] = formData[val.substring(1)];
              } else if (String(val).startsWith('#')) {
                obj[key] = null;
              }
            }

            osg.ajax(item.frontEndConfig.url, Object.assign({}, params, obj), res => {
              if (item.frontEndConfig.url.indexOf('org/query.do') != -1) {
                res.data.orgList.map(obj => {
                  obj.label =
                    item.frontEndConfig.label.indexOf('.') != -1
                      ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                          obj[item.frontEndConfig.label.split('.')[0]][
                            item.frontEndConfig.label.split('.')[1]
                          ]) ||
                        obj.name
                      : obj[item.frontEndConfig.label] || obj.name;
                  obj.value =
                    item.frontEndConfig.value.indexOf('.') != -1
                      ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                          obj[item.frontEndConfig.value.split('.')[0]][
                            item.frontEndConfig.value.split('.')[1]
                          ]) ||
                        obj.name
                      : obj[item.frontEndConfig.value] || obj._id;
                });
              } else {
                res.data.map(obj => {
                  obj.label =
                    item.frontEndConfig.label.indexOf('.') != -1
                      ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                          obj[item.frontEndConfig.label.split('.')[0]][
                            item.frontEndConfig.label.split('.')[1]
                          ]) ||
                        obj.name
                      : obj[item.frontEndConfig.label] || obj.name;
                  obj.value =
                    item.frontEndConfig.value.indexOf('.') != -1
                      ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                          obj[item.frontEndConfig.value.split('.')[0]][
                            item.frontEndConfig.value.split('.')[1]
                          ]) ||
                        obj.name
                      : obj[item.frontEndConfig.value] || obj._id;
                });
              }
              if (item.type == 'request') {
                window.$this.requestOptions[item.valueOption || item.name] = res.data;
              } else if (optsName) {
                window.$this[optsName][item.valueOption] = res.data;
              } else {
                if (item.frontEndConfig.url.indexOf('org/query.do') != -1) {
                  window.$this.options[item.valueOption] = res.data.orgList;
                } else {
                  window.$this.options[item.valueOption] = res.data;
                }
              }
              window.$this.$forceUpdate();
            });

            // 参照-表格形式展示
            if (item.type == 'request' && item.frontEndConfig.componentType == 'table') {
              osg.getFields(
                item.frontEndConfig.colName || '',
                null,
                null,
                'options.' + (item.valueOption || item.name) + 'Fields',
                item.frontEndConfig.extId,
                null,
                null,
                'requestOptions'
              );
            }
          }

          // 列不固定时删除fixed字段，解决el-table-column组件fixed为空字符串依然固定在左侧的问题
          if (!item.fixed) {
            delete item.fixed;
          }
        }

        window.$this.subFields = res.data;
        window.$this.$forceUpdate();

        // 批量请求字典表
        osg.codeoption(() => {
          osg.getExtForm(extId);
        });
      },
      { noload: true }
    );
  },
  getExtByColName(colName, callback) {
    osg.ajax('biz/ext/queryByColName/' + colName + '.do', {}, res => {
      if (callback) callback(res.entity._id);
    });
  },
  getExtForm(extId) {
    let params = {};
    // TODO:仕高玛 "机台类型-配件模板"和"机台档案-配件模板"，都查询"配件模板"的数据
    if (extId == '4544231225343230891') extId = '3390038025393947414';
    if (extId == '3390038025393947414') {
      params = {
        _all: '1',
        'ne:state|integer#and': -1,
        'exists:sid|boolean#and': true,
        'is:machineType|string#and': window.$this.formData.machineType
      };
    } else {
      params = { _all: '1', 'ne:state|integer#and': -1, sid: window.$this.formData._id };
    }
    osg.ajax(
      'biz/extForm/query/' + extId + '.do',
      params,
      res => {
        window.$this.subData = res.data;
      },
      { noload: true }
    );
  },
  saveExtForm(extId, formData) {
    if (osg.validate('subFormData')) {
      formData.sid = window.$this.formData._id;
      // TODO:仕高玛 "机台类型-配件模板"的数据存到"配件模板"
      if (extId == '4544231225343230891') {
        extId = '3390038025393947414';
        formData.machineType = window.$this.formData.machineType;
        formData.machineTypeName = window.$this.formData.name;
      }
      osg.ajax(`biz/extForm/upsert/${extId}.do`, { dataStr: JSON.stringify(formData) }, () => {
        osg.getExtForm(extId);
        osg.subInit();
      });
    }
  },
  editExtForm(row) {
    window.$this.subFormData = row;
    window.$this.openExtDetail = true;
  },
  removeExtForm(row) {
    let extId = window.$this.activeExt._id;
    if (extId == '4544231225343230891') extId = '3390038025393947414';
    osg.confirm('是否确认删除？', () => {
      osg.ajax(`biz/extForm/remove/${extId}.do`, { formDataId: row._id }, () => {
        osg.getExtForm(extId);
        osg.toast('删除成功');
      });
    });
  },
  subInit(open) {
    window.$this.openExtDetail = false;
    window.$this.subFormData = { sid: window.$this.formData._id, state: 1, exts: {} };
    if (open == true) {
      window.$this.openExtDetail = true;
    }
    window.$this.$nextTick(() => {
      if (
        window.$this.$refs['subFormData'] &&
        window.$this.$refs['subFormData'].$refs['formData']
      ) {
        window.$this.$refs['subFormData'].$refs['formData'].clearValidate();
      }
    });
  },
  tabClick(tab) {
    switch (tab.name) {
      case 'log':
        window.$this.getLog();
        return;
      case 'notes':
        window.$this.getNote();
        return;
      case 'history':
        window.$this.getHistory();
        return;
    }
    let exts = window.$this.subExts || [];
    for (let ext of exts) {
      if (tab.name == ext.colName) {
        window.$this.activeExt = ext;
        osg.getSubFields(ext.colName, ext._id);
        break;
      }
    }
  },
  /**
   * codecfg代码表组件，根据data中options内codecfg_开头的代码表组件配置进行批量初始化
   *
   * @param {*} callback 代码表组件初始化之后的回调，比如进行表格数据的加载和利用formater进行代码表数据转换展现
   */
  async codeoption(callback, that, optsName, tenantId) {
    if (window.navData) {
      let actionRole = window.navData.actionRole || {};
      var dataAuth = actionRole.dataAuth;
    }
    that = that || window.$this;
    let opts = {};
    if (optsName) {
      if (optsName.indexOf('.') != -1) {
        let key = optsName.split('.')[0];
        let value = optsName.split('.')[1];
        if (that[key][value]) {
          opts = that[key][value];
        } else {
          that.$set(that[key], value, {});
          opts = that[key][value];
        }
      } else {
        opts = that[optsName];
      }
    } else {
      opts = that.options;
    }
    if (opts) {
      var cfgArr = [];
      var cascadeTypes = []; //级联的代码类型
      let codeAuthObj = {}; // 汇总有数据权限的字典
      for (var o in opts) {
        if (o.startsWith('codecfg_')) {
          let cfg = opts[o];
          cfg['eleid'] = o.substring(8);

          // 汇总有数据权限的字典
          if (cfg.frontEndConfig && cfg.frontEndConfig.codeAuth) {
            codeAuthObj[o.substring(8)] = cfg.frontEndConfig.codeAuth;
          }
          delete cfg.frontEndConfig;

          cfgArr.push(cfg);
          delete opts[o];
        }
        //组合级联代码类型
        if (o.startsWith('cascadeCode_')) {
          let cfg = opts[o];
          let type = o.substring(12);

          // 汇总有数据权限的字典
          if (cfg.frontEndConfig && cfg.frontEndConfig.codeAuth) {
            codeAuthObj[o.substring(12)] = cfg.frontEndConfig.codeAuth;
          }
          delete cfg.frontEndConfig;

          cascadeTypes.push(type);
          delete opts[o];
        }
      }
      await new Promise(resolve => {
        if (cfgArr.length > 0) {
          let params = JSON.stringify(cfgArr);
          this.ajax(
            'i/code/selectCode.do',
            {
              jsonPara: params,
              tenantId: tenantId || null
            },
            res => {
              if (res) {
                res = JSON.parse(res);
                for (var i = 0; i < res.length; i++) {
                  var opts = res[i],
                    os = opts.options;
                  var osArr = [];
                  // 有数据权限的字典
                  if (codeAuthObj[opts.eleid]) {
                    let codeAuth = codeAuthObj[opts.eleid];
                    if (codeAuth.dataAuth && codeAuth.dataAuth.indexOf(dataAuth) != -1) {
                      // 限制当前数据权限的
                      for (var opt in os) {
                        if (codeAuth.contains && codeAuth.contains.length > 0) {
                          if (codeAuth.contains.indexOf(opt) != -1) {
                            osArr.push({
                              label: os[opt],
                              value: opt
                            });
                          }
                        } else if (codeAuth.doesNotContain && codeAuth.doesNotContain.length > 0) {
                          if (codeAuth.doesNotContain.indexOf(opt) == -1) {
                            osArr.push({
                              label: os[opt],
                              value: opt
                            });
                          }
                        }
                      }
                    } else {
                      for (let opt in os) {
                        osArr.push({
                          label: os[opt],
                          value: opt
                        });
                      }
                    }
                  } else {
                    for (let opt in os) {
                      osArr.push({
                        label: os[opt],
                        value: opt
                      });
                    }
                  }
                  // 行政区划字段选项不直接从字典表取值，根据当前登录人获取：运营中心组织及下面组织人员可选择城市运营上维护的行政区划，非运营中心下人员(平台)允许查看全部字典表数据。
                  if (opts.eleid == 'regions') {
                    osArr = osArr.filter(item => osg.myRegions.indexOf(item.value) != -1);
                  }
                  if (optsName) {
                    if (optsName.indexOf('.') != -1) {
                      let key = optsName.split('.')[0];
                      let value = optsName.split('.')[1];
                      that[key][value][opts.eleid] = osArr;
                    } else {
                      that[optsName][opts.eleid] = osArr;
                    }
                    if (that.$refs.form && that.$refs.form.$refs.table) {
                      window.$this.refresh();
                    }
                  } else {
                    that.options[opts.eleid] = osArr;
                  }
                }
                resolve();
              }
            },
            {
              noload: true
            }
          );
        } else {
          resolve();
        }
      });
      await new Promise(resolve => {
        //查询级联代码表数据
        if (cascadeTypes.length > 0) {
          this.ajax(
            'i/code/selectMultistageCode.do',
            {
              types: cascadeTypes.join(),
              tenantId: tenantId || JSON.parse(sessionStorage['entity']).tenantId
            },
            res => {
              if (res.constructor == Array) {
                res.map(item => {
                  if (codeAuthObj[item.type]) {
                    // 有数据权限的字典
                    let codeAuth = codeAuthObj[item.type];
                    if (codeAuth.dataAuth && codeAuth.dataAuth.indexOf(dataAuth) != -1) {
                      // 限制当前数据权限的
                      if (codeAuth.contains && codeAuth.contains.length > 0) {
                        item.children.map(obj => {
                          if (codeAuth.contains.indexOf(obj.value) == -1) {
                            obj.disabled = true;
                          }
                        });
                        if (optsName) {
                          if (optsName.indexOf('.') != -1) {
                            let key = optsName.split('.')[0];
                            let value = optsName.split('.')[1];
                            that[key][value][item.type] = osg.removeEmpty(
                              item.children,
                              'children'
                            );
                          } else {
                            that[optsName][item.type] = osg.removeEmpty(item.children, 'children');
                          }
                        } else {
                          that.options[item.type] = osg.removeEmpty(item.children, 'children');
                        }
                      } else if (codeAuth.doesNotContain && codeAuth.doesNotContain.length > 0) {
                        item.children.map(obj => {
                          if (codeAuth.doesNotContain.indexOf(obj.value) != -1) {
                            obj.disabled = true;
                          }
                        });
                        if (optsName) {
                          if (optsName.indexOf('.') != -1) {
                            let key = optsName.split('.')[0];
                            let value = optsName.split('.')[1];
                            that[key][value][item.type] = osg.removeEmpty(
                              item.children,
                              'children'
                            );
                          } else {
                            that[optsName][item.type] = osg.removeEmpty(item.children, 'children');
                          }
                        } else {
                          that.options[item.type] = osg.removeEmpty(item.children, 'children');
                        }
                      }
                    } else {
                      if (optsName) {
                        if (optsName.indexOf('.') != -1) {
                          let key = optsName.split('.')[0];
                          let value = optsName.split('.')[1];
                          that[key][value][item.type] = osg.removeEmpty(item.children, 'children');
                        } else {
                          that[optsName][item.type] = osg.removeEmpty(item.children, 'children');
                        }
                      } else {
                        that.options[item.type] = osg.removeEmpty(item.children, 'children');
                      }
                    }
                  } else {
                    if (optsName) {
                      if (optsName.indexOf('.') != -1) {
                        let key = optsName.split('.')[0];
                        let value = optsName.split('.')[1];
                        that[key][value][item.type] = osg.removeEmpty(item.children, 'children');
                      } else {
                        that[optsName][item.type] = osg.removeEmpty(item.children, 'children');
                      }
                    } else {
                      that.options[item.type] = osg.removeEmpty(item.children, 'children');
                    }
                  }
                });
              }
              resolve();
            },
            {
              noload: true
            }
          );
        } else {
          resolve();
        }
      });

      if (callback) callback();
    }
  },
  // 删除空数组
  removeEmpty(arr, childrenName = 'children') {
    if (Array.isArray(arr)) {
      arr.forEach(item => {
        if (item[childrenName] ? item[childrenName].length === 0 : false) {
          delete item[childrenName];
        } else {
          this.removeEmpty(item[childrenName], childrenName);
        }
      });
      return arr;
    }
  },
  /**
   * 代码表组件，将代码表value转换为label，比如用于表格formatter进行数据列值的代码表转换
   *
   * @param {*} codeType 代码表类型，data中options中代码表key，也可以是是codecfg_组件生成(需在codeoptions初始化之后)
   * @param {*} codeValue 需要转换为名称的的代码表值
   */
  //codeValue为字符串、opt.value为字符串; notFormat:当匹配不到label时,显示字段值不显示未知
  codelabel: function(codeType, codeValue, that, notFormat, options) {
    that = that || window.$this;
    if (codeType) {
      var opts =
        options ||
        that.options[codeType] ||
        that.options[codeType.toLowerCase()] ||
        (that.requestOptions && that.requestOptions[codeType]); // 避免有些字典表codeType是大写,预置没有
    }
    if (opts) {
      for (var i = 0; i < opts.length; i++) {
        if (codeValue == opts[i].value) return opts[i].label;
      }
    }
    if (!codeValue) {
      return codeValue;
    } else {
      return notFormat ? codeValue : '未知';
    }
  },
  //value为数组、opt.value为字符串
  codelabelForArray: function(codeType, codeValue, options) {
    if (codeType) {
      var opts =
        options ||
        window.$this.options[codeType] ||
        window.$this.options[codeType.toLowerCase()] ||
        (window.$this.requestOptions && window.$this.requestOptions[codeType]); // 避免有些字典表codeType是大写,预置没有
    }
    if (opts && codeValue) {
      var str = '';
      for (var i = 0; i < opts.length; i++) {
        for (var j = 0; j < codeValue.length; j++) {
          if (codeValue[j] == opts[i].value) str += opts[i].label + '、';
        }
      }
      str = str.substring(0, str.length - 1);
      return str;
    }
    if (!codeValue) {
      return codeValue;
    } else {
      return '未知';
    }
  },
  //value为字符串、opt.value为数组
  codelabelInArray: function(codeType, codeValue, options) {
    if (codeType) {
      var opts =
        options || window.$this.options[codeType] || window.$this.options[codeType.toLowerCase()]; // 避免有些字典表codeType是大写,预置没有
    }
    if (opts && codeValue) {
      for (let i = 0; i < opts.length; i++) {
        if (opts[i].value.indexOf(codeValue) != -1) {
          return opts[i].label;
        }
      }
    }
    if (!codeValue) {
      return codeValue;
    } else {
      return '未知';
    }
  },
  // 返显单选级联
  formatCascade(option, arr, options) {
    try {
      if (!arr) {
        return;
      }
      if (window.$this.$util.isJson(arr)) {
        arr = JSON.parse(arr);
      }
      let str = '';
      if (!window.$this.options && !options) return;
      let opts = options || window.$this.$util.deepCopy(window.$this.options[option]);
      if (!opts || opts.constructor != Array) {
        return;
      }
      // 单选级联 有几级循环几次
      for (var i = 0; i < arr.length; i++) {
        if (!Array.isArray(opts)) {
          continue;
        }
        for (var opt of opts) {
          if (opt.value == arr[i]) {
            str += (opt.label || opt.name) + ' / ';
            opts = window.$this.$util.deepCopy(opt.children);
            break;
          }
        }
      }
      return str.slice(0, str.length - 2);
    } catch (error) {
      console.error('common.js文件下formatCascade方法报错');
      console.error(error);
      console.log(option, arr);
      return;
    }
  },
  // 返显多选级联
  formatCascadeMultiple(option, array, options) {
    try {
      if (!array) {
        return;
      }
      if (window.$this.$util.isJson(array)) {
        array = JSON.parse(array);
      }
      let string = '';
      // 多选级联 有几个循环几次
      for (let arr of array) {
        let str = '';
        let opts = options || window.$this.$util.deepCopy(window.$this.options[option]);
        if (!opts || opts.constructor != Array) {
          return;
        }
        //有几级循环几次
        for (let i = 0; i < arr.length; i++) {
          for (let opt of opts) {
            if (opt.value == arr[i]) {
              str += (opt.label || opt.name) + ' / ';
              opts = window.$this.$util.deepCopy(opt.children);
              break;
            }
          }
        }
        string += str.slice(0, str.length - 2) + '、';
      }
      return string.slice(0, string.length - 1);
    } catch (error) {
      console.log(error);
    }
  },
  /**
   * 返显省市区
   */
  formatArea(arr) {
    if (!arr) return;
    let str = '';
    if (arr[0]) str += osg.areaObj.province_list[arr[0]];
    if (arr[1]) str += ' / ' + osg.areaObj.city_list[arr[1]];
    if (arr[2]) str += ' / ' + osg.areaObj.county_list[arr[2]];
    return str;
  },
  formatProvince(row, column, cellValue) {
    return osg.areaObj.province_list[cellValue];
  },
  formatCity(row, column, cellValue) {
    return osg.areaObj.city_list[cellValue];
  },
  formatDistrict(row, column, cellValue) {
    return osg.areaObj.county_list[cellValue];
  },
  formatSubdistrict(row, column, cellValue) {
    return osg.areaObj.street_list[cellValue] || cellValue;
  },
  /**
   * 返显区号
   */
  formatCityCode(row, column, cellValue) {
    if (!cellValue) {
      return '';
    }
    for (let item of cityCode.data) {
      if (cellValue == item.code) {
        return (item.province ? item.province + ' ' : '') + item.city;
      }
    }
  },
  /**
   * 获取街道
   */
  getSubdistricts(arr, callback) {
    if (arr && arr.length >= 3) {
      osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          parentCode: arr[2],
          level: '4',
          sortField: 'code',
          sortOrder: 'asc',
          areaTranslation: '1' // 同时返回补充的街道
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = true;
          });
          if (callback) {
            callback(res.data);
          }
        },
        {
          noload: true
        }
      );
    } else {
      if (callback) {
        callback([]);
      }
    }
  },
  /**
   * 返显计算后的值
   */
  renderCompute(formula) {
    return eval(formula);
  },
  /**
   * 列表返显计算后的值
   */
  renderComputeRow(formula, scope) {
    return eval(formula);
  },
  /**
   * 七牛云存储
   *
   */
  /**
   * 七牛云下载地址
   */
  downloadUrl: 'https://pub.fsgo365.cn/',
  // downloadUrl: 'http://qiniu.sicoma.com.cn/', // 仕高玛
  /**
   * 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传
   * @param {*} file 文件
   * @param {*} format 文件类型
   * @param {*} dynamicData
   * @param {*} isQuill 富文本编辑器上传图片
   */
  async beforeUpload(file, format, dynamicData, that, isQuill, isPrivate) {
    window.$this = that || window.$this;
    if (format == 'image') {
      const isImage =
        file.type === 'image/jpg' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        osg.toast('上传图片只能是 jpg/jpeg/png/gif 格式!', 'error');
        return false;
      }
    } else if (format == 'excel') {
      const isExcel = file.name.split('.')[1] === 'xls' || file.name.split('.')[1] === 'xlsx';
      if (!isExcel) {
        osg.toast('上传文件只能是 xls、xlsx格式!', 'error');
        return false;
      }
    } else if (format == 'video') {
      const ismp4 = file.type === 'video/mp4';
      const isogg = file.type === 'video/ogg';
      const isflv = file.type === 'video/flv';
      const isavi = file.type === 'video/avi';
      const iswmv = file.type === 'video/wmv';
      const isrmvb = file.type === 'video/rmvb';
      // const isLt100M = file.size / 1024 / 1024 < 100;
      if (!ismp4 && !isogg && !isflv && !isavi && !iswmv && !isrmvb) {
        osg.toast('请上传正确的视频格式!', 'error');
        return false;
      }
    } else if (format) {
      if (
        format &&
        !format.includes(
          file.name
            .split('.')
            .pop()
            .toLowerCase()
        ) &&
        format != 'media' &&
        format != 'all'
      ) {
        osg.toast(`上传文件只能是${format}格式!`, 'error');
        return false;
      }
    }

    let tenantConfig = osg.tenantConfig;
    if (typeof tenantConfig == 'undefined') {
      await new Promise(resolve => {
        osg.ajax(
          'back/super/file/upToken.do',
          {
            fileName: file.name,
            isPrivate: isPrivate
          },
          res => {
            if (isQuill) {
              isQuill[dynamicData ? dynamicData : 'upload'].data = res;
              isQuill[dynamicData ? dynamicData : 'upload'].url = 'http://up-z1.qiniup.com';
            } else {
              window.$this[dynamicData ? dynamicData : 'upload'].data = res;
              window.$this[dynamicData ? dynamicData : 'upload'].url = 'http://up-z1.qiniup.com';
            }
            resolve();
          },
          {
            noload: true
          }
        );
      });
    } else {
      if (tenantConfig.uploadMode == 1) {
        if (isQuill) {
          isQuill[dynamicData ? dynamicData : 'upload'].url = rootUri + 'ftp/upload.do';
        } else {
          window.$this[dynamicData ? dynamicData : 'upload'].url = rootUri + 'ftp/upload.do';
        }
      } else if (tenantConfig.uploadMode == 2) {
        if (isQuill) {
          isQuill[dynamicData ? dynamicData : 'upload'].url = rootUri + 'localShare/upload.do';
        } else {
          window.$this[dynamicData ? dynamicData : 'upload'].url = rootUri + 'localShare/upload.do';
        }
      } else {
        await new Promise(resolve => {
          osg.ajax(
            'back/super/file/upToken.do',
            {
              fileName: file.name,
              isPrivate: isPrivate || null
            },
            res => {
              if (isQuill) {
                isQuill[dynamicData ? dynamicData : 'upload'].data = res;
                isQuill[dynamicData ? dynamicData : 'upload'].url = 'http://up-z1.qiniup.com';
              } else {
                window.$this[dynamicData ? dynamicData : 'upload'].data = res;
                window.$this[dynamicData ? dynamicData : 'upload'].url = 'http://up-z1.qiniup.com';
              }
              resolve();
            },
            {
              noload: true
            }
          );
        });
      }
    }
  },
  /**
   * 文件上传成功时的钩子
   * @param {*} response
   * @param {*} file
   * @param {*} fileList
   * @param {*} field 字段名 如:formData.exts.images
   * @param {*} extFields
   * @param {*} isQuill 富文本编辑器上传图片
   */
  uploadSuccess(
    response,
    formDataName = 'formData',
    fileList,
    field,
    extFields,
    that,
    isQuill,
    callback
  ) {
    that = that || window.$this;
    if (isQuill == 'quill') {
      if (window.$this.$refs.editor) {
        let quill = window.$this.$refs.editor.$refs.myQuillEditor.quill;
        if (!quill) return;
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片
        if (response.key) {
          let index = response.key.lastIndexOf('.');
          if (index != -1) {
            let suffix = response.key.substring(index + 1);
            if (suffix) {
              if (
                ['jpg', 'jpeg', 'png', 'gif', 'JPG', 'JPEG', 'PNG', 'GIF'].indexOf(suffix) != -1
              ) {
                // 图片
                quill.insertEmbed(length, 'image', osg.downloadUrl + response.key);
              } else {
                // 文件
                let fileNameLength = response.key.length;
                // 插入链接
                quill.insertEmbed(
                  length,
                  'link',
                  { href: osg.downloadUrl + response.key, innerText: response.key },
                  'api'
                );
                quill.setSelection(length + fileNameLength);
              }
            }
          }
        } else if (response.data && response.data.url) {
          let index = response.data.oldFileName.lastIndexOf('.');
          if (index != -1) {
            let suffix = response.data.oldFileName.substring(index + 1);
            if (suffix) {
              if (
                ['jpg', 'jpeg', 'png', 'gif', 'JPG', 'JPEG', 'PNG', 'GIF'].indexOf(suffix) != -1
              ) {
                // 图片
                quill.insertEmbed(length, 'image', response.data.url);
              } else {
                // 文件
                let fileNameLength = response.data.oldFileName.length;
                // 插入链接
                quill.insertEmbed(
                  length,
                  'link',
                  { href: response.data.url, innerText: response.data.oldFileName },
                  'api'
                );
                quill.setSelection(length + fileNameLength);
              }
            }
          }
        } else {
          return;
        }
      } else if (window.$this.$refs.form && window.$this.$refs.form.$refs.editor) {
        let editors = window.$this.$refs.form.$refs.editor;
        for (let i = 0; i < editors.length; i++) {
          let quill = editors[i].$refs.myQuillEditor.quill;
          if (
            !editors[i].$refs.myQuillEditor.quill ||
            !editors[i].$refs.myQuillEditor.quill.getSelection()
          ) {
            continue;
          }
          // 获取光标所在位置

          let length = editors[i].$refs.myQuillEditor.quill.getSelection().index;
          // 插入图片
          if (response.key) {
            let index = response.key.lastIndexOf('.');
            if (index != -1) {
              let suffix = response.key.substring(index + 1);
              if (suffix) {
                if (
                  ['jpg', 'jpeg', 'png', 'gif', 'JPG', 'JPEG', 'PNG', 'GIF'].indexOf(suffix) != -1
                ) {
                  // 图片
                  quill.insertEmbed(length, 'image', osg.downloadUrl + response.key);
                  // 调整光标到最后
                  quill.setSelection(length + 1);
                } else {
                  // 文件
                  let fileNameLength = response.key.length;
                  // 插入链接
                  quill.insertEmbed(
                    length,
                    'link',
                    { href: osg.downloadUrl + response.key, innerText: response.key },
                    'api'
                  );
                  quill.setSelection(length + fileNameLength);
                }
              }
            }
          } else if (response.data && response.data.url) {
            let index = response.data.oldFileName.lastIndexOf('.');
            if (index != -1) {
              let suffix = response.data.oldFileName.substring(index + 1);
              if (suffix) {
                if (
                  ['jpg', 'jpeg', 'png', 'gif', 'JPG', 'JPEG', 'PNG', 'GIF'].indexOf(suffix) != -1
                ) {
                  // 图片
                  quill.insertEmbed(length, 'image', response.data.url);
                  // 调整光标到最后
                  quill.setSelection(length + 1);
                } else {
                  // 文件
                  let fileNameLength = response.data.oldFileName.length;
                  // 插入链接
                  quill.insertEmbed(
                    length,
                    'link',
                    { href: response.data.url, innerText: response.data.oldFileName },
                    'api'
                  );
                  // 调整光标到最后
                  quill.setSelection(length + fileNameLength);
                }
              }
            }
          } else {
            return;
          }
        }
      }
    } else {
      if (!extFields) {
        if (field) {
          if (field.indexOf('exts') != -1) {
            if (field.split('.').length == 2) {
              that[formDataName].exts[field] = fileList;
            } else if (field.split('.').length == 3) {
              that[field.split('.')[0]].exts[field.split('.')[2]] = fileList;
            }
          } else {
            if (field.split('.').length == 1) {
              that[formDataName][field] = fileList;
            } else if (field.split('.').length == 2) {
              that[field.split('.')[0]][field.split('.')[1]] = fileList;
            }
          }
        }
      }
      if (callback) callback();
      return fileList;
    }
  },
  /**
   * 文件上传失败时的钩子
   */
  uploadError() {
    osg.toast('上传失败', 'error');
  },
  /**
   * 删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
   * @param {*} file 字段名 如:formData.exts.images
   * @param {*} fileList
   * @param {*} field
   * @param {*} extFields
   * @param {*} callback
   */
  beforeRemove(
    file,
    formDataName = 'formData',
    field,
    extFields,
    callback,
    that = window.$this,
    noDelete = false
  ) {
    var list = [];
    if (!extFields) {
      if (field) {
        if (field.indexOf('exts') != -1) {
          if (field.split('.').length == 2) {
            list = that[formDataName].exts[field];
          } else if (field.split('.').length == 3) {
            list = that[field.split('.')[0]].exts[field.split('.')[2]];
          }
        } else {
          if (field.split('.').length == 1) {
            list = that[formDataName][field];
          } else if (field.split('.').length == 2) {
            list = that[field.split('.')[0]][field.split('.')[1]];
          }
        }
      }
    } else {
      list = extFields;
    }
    if (file.response) {
      for (let i = 0; i < list.length; i++) {
        if (file.response.key == list[i].response.key) {
          list.splice(i, 1);
          if (!extFields) {
            that.doSave && that.doSave();
          }
          break;
        }
      }
      file.response.key = file.response.key.replace(osg.downloadUrl, '');
      // if (!noDelete) {
      //   osg.ajax(`back/super/file/delete/${file.response.key}.do`, null, () => {}, {
      //     method: 'GET'
      //   });
      // }
    } else if (file.uid) {
      for (let i = 0; i < list.length; i++) {
        if (file.uid == list[i].uid) {
          list.splice(i, 1);
          if (!extFields) {
            that.doSave && that.doSave();
          }
          break;
        }
      }
    }
    if (callback) callback();
    return list;
  },
  // on-preview	点击文件列表中已上传的文件时的钩子
  uploadPreview(file, that) {
    window.$this = that || window.$this;
    console.log('当前预览的文件', file);
    let format = file.name && Array.isArray(file.name) ? file.name.split('.')[1] : '';
    if (file.url) {
      if (format != 'jpg' && format != 'jpeg' && format != 'png' && format != 'gif') {
        window.open(file.url);
      } else {
        window.$this.upload.dialogImageUrl = file.url;
        window.$this.upload.dialogVisible = true;
      }
    } else {
      if (file.response) {
        if (file.response.key) {
          window.open(osg.downloadUrl + file.response.key);
        } else if (file.response.data && file.response.data.url) {
          window.open(file.response.data.url);
        }
      }
    }
  },
  // 文件超出个数限制时的钩子
  uploadExceed(files, fileList) {
    osg.toast(`当前限制上传 ${fileList.length} 个文件`, 'warning');
    // ，本次选择了 ${files.length} 个文件，共选择了 ${files.length +
    //   fileList.length} 个文件
    return false;
  },
  /**
   * 地理编码
   * 高德地图企业Key：222af85515a49668992817ba7d564425
   * 高德地图个人Key：1544e78c6949e7843efff0691ce9dc67
   */
  geocode(address, callback, city) {
    osg.ajax(
      `~https://restapi.amap.com/v3/geocode/geo?key=1544e78c6949e7843efff0691ce9dc67&address=
        ${address}&city=${city || ''}`,
      {},
      res => {
        if (res.status) {
          if (callback) callback(res.geocodes[0]);
        } else {
          osg.toast('请补充地址信息', 'error');
          return;
        }
      },
      {
        noload: true
      }
    );
  },
  /**
   * 逆-地理编码 根据经纬度查地址
   */
  geocodeRegeo(location, callback, returnAddr = true) {
    osg.ajax(
      '~https://restapi.amap.com/v3/geocode/regeo',
      {
        key: '1544e78c6949e7843efff0691ce9dc67',
        location,
        extensions: 'base', // 返回结果控制
        batch: false //batch=true为批量查询。batch=false为单点查询
      },
      res => {
        if (res.status == '1') {
          let addressComponent = returnAddr ? res.regeocode.addressComponent : res.regeocode;
          callback(addressComponent);
        } else {
          callback(null);
          osg.toast('暂无查询到数据，请自行选择街道', 'error');
          return;
        }
      },
      {
        noload: true
      }
    );
  },
  /**
   * 输入提示
   */
  inputtips(queryString, callback, that = null) {
    // 处理一下 输入框聚焦的时候 不发送请求
    if (!queryString || !queryString.trim()) {
      return; // 如果 queryString 为空，直接返回，不发起请求
    }
    //当前是否打开了地图选址弹出窗
    let openMapStatus = that && that.record && that.record.openMap;

    osg.ajax(
      '~https://restapi.amap.com/v3/assistant/inputtips',
      {
        key: '1544e78c6949e7843efff0691ce9dc67',
        keywords: queryString,
        city:
          !openMapStatus &&
          window.$this.formData &&
          window.$this.formData.area &&
          window.$this.formData.area[2],
        // citylimit:true 仅返回指定城市数据
        citylimit:
          window.$this.formData && window.$this.formData.area && window.$this.formData.area[2]
            ? true
            : false
      },
      res => {
        res.tips.map(item => {
          // 处理一下 如果是封装的地图选点弹窗 处理一下返回数据
          if (item.location && !Array.isArray(item.location)) {
            item.value = openMapStatus ? item.district + item.address + item.name : item.name;
          }
        });
        callback(res.tips);
      }
    );
  },

  /**
   * 根据选择的输入提示地址查询到所属的省市区街道编码、经纬度并赋值
   */
  async inputtipsSelect(item, subdistricts = 'subdistricts', _that) {
    //赋值省市区编码、经纬度
    let that = _that ? _that : window.$this;
    let areaData = {
      province: item.adcode.slice(0, 2) + '0000',
      city: item.adcode.slice(0, 4) + '00',
      district: item.adcode,
      area: [item.adcode.slice(0, 2) + '0000', item.adcode.slice(0, 4) + '00', item.adcode],
      gpsPoint: {
        longitude: item.location.split(',')[0],
        latitude: item.location.split(',')[1]
      }
    };
    if (
      areaData.province.startsWith('810') ||
      areaData.province.startsWith('820') ||
      areaData.province.startsWith('710')
    ) {
      osg.toast('港澳台请自行选择省市区', 'error');
      return;
    } else {
      //根据经纬度查询街道的编码
      osg.geocodeRegeo(item.location, addressComponent => {
        // 去掉后三位街道编码，和数据库街道编码格式保持一致
        areaData.subdistrict = addressComponent.towncode.slice(
          0,
          addressComponent.towncode.length - 3
        );
        //获取当前区下的所有街道供选择
        osg.getSubdistricts(areaData.area, result => {
          that.options[subdistricts] = result;
          if (!result.find(item => item.code == areaData.subdistrict)) {
            let obj = {
              label: addressComponent.township,
              value: addressComponent.township
            };
            that.options[subdistricts].push(obj);
            areaData.subdistrict = addressComponent.township;
          }
          //是否需要更新标记的位置  item.move为true 更新过无需更新
          if (that && !item.move) {
            const coordArray = item.location.split(',').map(Number);
            // 更新标记的位置
            that.record.mapMarker.setPosition(coordArray);
            that.record.map.setZoomAndCenter(18, coordArray);
          }

          window.$this.$forceUpdate();
          if (window.$this.record && window.$this.record.openRecord) {
            window.$this.record.SArecordFormData = window.$this.$util.deepCopy(
              Object.assign(window.$this.record.SArecordFormData, areaData)
            );
          } else if (that) {
            window.$this.formData = window.$this.$util.deepCopy(
              Object.assign(that.formData, areaData)
            );
          } else {
            osg.changeForm(areaData);
          }
        });
      });
    }
  },
  // c-form组件 修改页面formData自定义事件
  changeForm(data) {
    window.$this.formData = window.$this.$util.deepCopy(Object.assign(window.$this.formData, data));
  },
  getCityData(id, callback) {
    window.$this.osg.ajax(
      'division/queryCity.do',
      {
        _id: id
      },
      res => {
        if (callback) callback(res);
      },
      {
        noload: true
      }
    );
  },
  /**
   * 文件流转文件下载
   * @param {*} res 文件流
   */
  convertToFile(res) {
    //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
    let temp = res.headers['content-disposition'].split('=')[1];
    let iconv = require('iconv-lite');
    iconv.skipDecodeWarning = true; //忽略警告
    var fileName = iconv.decode(temp, 'gbk');

    const _res = res.data;
    var blob = new Blob([_res]);
    let downloadElement = document.createElement('a');
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  },
  /**
   * 数据导出
   */
  export(smodule, params, obj) {
    obj = obj || {};
    if (!obj.noFilter) {
      //noFilter:true 不需要过滤
      if (window.$that) {
        window.$that.getParams(params);
      }
    }
    osg.ajax(
      obj.hash || `/basic/${smodule}/export.do`,
      params,
      res => {
        //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
        let temp = res.headers['content-disposition'].split('=')[1];
        let iconv = require('iconv-lite');
        iconv.skipDecodeWarning = true; //忽略警告
        var fileName = iconv.decode(temp, 'gbk');

        const _res = res.data;
        var blob = new Blob([_res]);
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      },
      {
        responseType: 'blob'
      }
    );
  },
  /**
   * 数据导出(通过传表头数据方式实现)
   */
  doExport(params, options, callback) {
    // options 参数 { dynamic:已升级动态列表需传递dynamic , that:页面的this指向}
    options = options || {};
    options.that = options.that || window.$this;
    options.url = options.url || 'excel/export.do';
    options.preset = options.preset || 1;
    options.headers = options.headers || {
      responseType: 'blob'
    };
    options.noAnalysis = options.noAnalysis || false; //是否不解析blob，默认是解析
    let paramObj = {};
    let searchObj = {};
    //如有调整，工单导出使用的是单独个方法，需要去工单也进行修改!
    if (window.$that) {
      window.$that.getParams(params);
    }
    for (let paramKey in params) {
      //给查询条件拼上 fpi-
      if (
        paramKey.indexOf('|') != -1 ||
        paramKey == 'sortField' ||
        paramKey == 'sortOrder' ||
        paramKey.startsWith('fpi-')
      ) {
        searchObj[paramKey.replace('fpi-', '')] = params[paramKey];
      } else {
        paramObj[paramKey] = params[paramKey];
      }
    }
    let headerList = []; //表头数据
    const extPrefix = 'exts.';
    let tableData = [];
    if (options.importFields) {
      // 下载导入字段表格
      tableData = options.that.extFields.filter(item => {
        return item.importFlag == 1 && item.customizeFlag == 1;
      });
    } else {
      tableData = options.dynamic
        ? options.that.extFields.filter(item => {
            return item.customizeFlag == 1;
          })
        : options.that.$refs.table.$children;
    }
    let currentRole = JSON.parse(sessionStorage['currentRole']);
    tableData.forEach(el => {
      if (options.dynamic) {
        // 不仅需要判断showList包含1，还需要判断当前角色是否展示
        if (
          el.showList &&
          el.showList.includes('1') &&
          (el.showType == '4' || el.showType == '5'
            ? currentRole
              ? el.showType == '4'
                ? el.roleIds.indexOf(currentRole._id) != -1
                  ? true
                  : false
                : el.roleIds.indexOf(currentRole._id) == -1
                ? true
                : false
              : false
            : true)
        ) {
          let obj = {};
          obj[options.importFields ? el.importName || el.nameDisp : el.nameDisp] = el.preset
            ? el.name
            : extPrefix + el.name;
          // 导出时需要指定使用哪个字典的，多加两个参数
          if (el.frontEndConfig && el.frontEndConfig.exportValueOption) {
            obj.valueOption = el.valueOption;
            obj.valueField = el.preset ? el.name : extPrefix + el.name;
          }
          headerList.push(obj);
        }
      } else {
        let obj = {};
        if (el.label || el.prop) {
          obj[el.label] =
            options.preset == '0' ? el.prop && el.prop.replace(extPrefix, '') : el.prop;
          // 导出时需要指定使用哪个字典的，多加两个参数
          if (el.$attrs.valueOption) {
            obj.valueOption = el.$attrs.valueOption;
            obj.valueField =
              options.preset == '0' ? el.prop && el.prop.replace(extPrefix, '') : el.prop;
          }
          headerList.push(obj);
        }
      }
    });
    // 下载导入字段表格
    if (options.importFields) {
      headerList.unshift({ id: '_id' });
      searchObj['importFields'] = '1';
    }

    if (!paramObj.beanName) paramObj.beanName = options.that.name; //表格名
    if (!paramObj.title) paramObj.title = options.that.name; //生成文件名
    if (!paramObj.preset) paramObj.preset = String(options.preset); //1代表系统预设，0租户扩展

    let jsonList = [];
    for (let pKey in paramObj) {
      let obj = {};
      obj[pKey] = paramObj[pKey];
      if (pKey) jsonList.push(obj);
    }
    jsonList = jsonList.concat(headerList);
    osg.ajax(
      options.url,
      Object.assign(searchObj, {
        jsonList: JSON.stringify(jsonList)
      }),
      res => {
        if (!options.noAnalysis) {
          // 对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let temp = res.headers['content-disposition'].split('=')[1];
          let iconv = require('iconv-lite');
          iconv.skipDecodeWarning = true; //忽略警告
          let fileName = iconv.decode(temp, 'gbk');
          const _res = res.data;
          let blob = new Blob([_res]);
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        }

        if (callback) callback();
      },
      options.headers
    );
  },
  getDocumentTemplates(colName, dataId, workflowDefId) {
    osg.ajax(
      'printTemplate/query.do',
      {
        _all: '1',
        'is:state|integer#and': 1,
        colName: colName,
        workflowDefId: workflowDefId,
        sortField: 'createTime',
        sortOrder: 'desc'
      },
      res => {
        res.data = res.data.map(item => {
          item.exts = item.exts || {};
          return item;
        });
        if (res.data.length == 0) {
          osg.toast('请先上传文件模板');
        } else if (res.data.length == 1) {
          osg.excelEditor(colName, res.data[0]._id, dataId);
          window.$this.documentTemplates = res.data;
        } else {
          window.$this.documentTemplates = res.data;
        }
      }
    );
  },
  excelEditor(colName, templateId, dataId) {
    let routeUrl = window.$this.$router.resolve({
      path: '/Excel',
      query: { colName, templateId, dataId }
    });
    window.open(routeUrl.href, '_blank');
  },
  // 下载二维码,支持传参数
  downloadQRCodes(params) {
    if (window.$that && !params.bizId) {
      window.$that.getParams(params);
    }
    osg.ajax(
      '/basic/qrcode/batchGenerate.do',
      params,
      res => {
        let temp = res.headers['content-disposition'].split('=')[1];
        let iconv = require('iconv-lite');
        iconv.skipDecodeWarning = true; //忽略警告
        let fileName = iconv.decode(temp, 'gbk');
        fileName = fileName.substring(1, fileName.length - 1);
        let blob = new Blob([res.data]);
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      },
      {
        responseType: 'blob'
      }
    );
  },
  /**
   * 判断字符串是否为json格式
   *
   */
  isJson: function($string) {
    try {
      if (typeof JSON.parse($string) == 'object') return true;
    } catch (e) {
      return false;
    }
  },
  /**
   * 集成智齿
   *
   */
  sobot: {
    url: 'https://www.sobot.com',
    data: {
      token: '20b7675c-93a3-4f7f-842d-19867a40ae87',
      companyId: '45630f16df14456bbdbc0287a14a11c9', //公司id
      appId: 'd27121d2712541be95d21fe1a597f735', //应用节点id
      number: '143530002', //坐席手机号、voip账号
      agentId: '6d6c46ef0b074007937c140c5197ab39', //坐席id //国东 6d6c46ef0b074007937c140c5197ab39 //董灿 bb5e3f9f63c7469ab45ec7d0a7234e52
      displayNumber: '02750183592', //外显号码
      groupId: '45630f16df14456bbdbc0287a14a11c9_3', //外呼时所在的技能组
      destinationNumber: '', //被叫号码
      params: '' //自定义参数 待测试
    },
    // 获取token及呼叫中心信息
    getToken(callback) {
      osg.ajax(
        '/basic/sobot/getSobotInformation.do',
        {},
        res => {
          osg.sobot.data = res.data;
          console.log(res.data);
          if (callback) callback();
        },
        {
          noload: true
        }
      );
      // if (callback) callback();
    },
    // 智齿外呼
    callOut(data) {
      this.getToken(() => {
        let params = {
          companyId: osg.sobot.data.companyId, //公司id
          appId: osg.sobot.data.appId, //应用节点id
          number: osg.sobot.data.number, //坐席手机号/voip账号
          agentId: osg.sobot.data.agentId, //坐席id
          displayNumber: osg.sobot.data.displayNumber, //外显号码
          groupId: osg.sobot.data.groupId, //外呼时所在的技能组
          destinationNumber: data.destinationNumber, //被叫号码
          params: data.params //自定义参数 待测试
        };
        osg.ajax(
          '~' +
            osg.sobot.url +
            '/comm/api/1/call/agentMakeCall?access_token=' +
            osg.sobot.data.token,
          params,
          res => {
            osg.toast(res.retCode == '000000' ? '正在呼叫中，请注意接听' : res.retMsg);
          },
          {
            header: { 'Content-Type': 'application/json', requestDataType: 'json' },
            noload: true
          }
        );
      });
    },
    //自己的外呼接口
    // selfCallOut(data, callback) {
    //   osg.ajax(
    //     'basic/sobot/agentMakeCall.do',
    //     {
    //       callNum: data.callNum, //被叫号码
    //       params: JSON.stringify({
    //         bizType: data.bizType,
    //         bizId: data.bizId,
    //         currentUserId: osg.isJson(sessionStorage['loginAccount'])
    //           ? JSON.parse(sessionStorage['loginAccount'])._id
    //           : null
    //       }) //自定义参数 待测试
    //     },
    //     res => {
    //       osg.toast(
    //         res.data.retCode == '000000' ? '正在呼叫中，请注意接听' : res.data.retMsg,
    //         res.success ? '' : 'error'
    //       );
    //       console.log(res.data);
    //       if (callback) callback(res.data);
    //     },
    //     {
    //       noload: true
    //     }
    //   );
    //   // });
    // }
    // 智齿外呼接口6.0
    selfCallOut(data, callback) {
      osg.ajax(
        '/basic/sobot/agentMakeCall.do',
        {
          callNum: data.callNum, //被叫号码
          params: JSON.stringify({
            bizType: data.bizType,
            bizId: data.bizId,
            currentUserId: osg.isJson(sessionStorage['loginAccount'])
              ? JSON.parse(sessionStorage['loginAccount'])._id
              : null
          }) //自定义参数 待测试
        },
        res => {
          console.log(res, '外呼res');
          // 客服座机接听
          osg.ajax(
            '/basic/sobot/agentAnswerCall.do',
            {},
            res => {
              console.log(res, '接听res');
            },
            {
              noload: true
            }
          );
          // osg.toast(
          //   res.data.retCode == '000000' ? '正在呼叫中，请注意接听' : res.data.retMsg,
          //   res.success ? '' : 'error'
          // );
          if (callback) callback(res.data);
        },
        {
          noload: true
        }
      );
      // });
    }
  },
  /**
   *
   * 操作权限
   */
  has(value) {
    if (
      osg.isJson(sessionStorage['buttons']) &&
      JSON.parse(sessionStorage['buttons'])[value.split(',')[0]]
    ) {
      // 有这个菜单权限
      if (
        JSON.parse(sessionStorage['buttons'])[value.split(',')[0]].indexOf(value.split(',')[1]) !=
        -1
      ) {
        // 有这个菜单下的按钮或标签页
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  /**
   * 判断是否重复提交
   */
  clickTime: {},
  isRepeatClick(btn, ms) {
    let clickTime = new Date().getTime();
    if (osg.clickTime[btn]) {
      if (clickTime - osg.clickTime[btn] < ms) {
        osg.toast('操作过于频繁', 'warning');
        return true;
      } else {
        osg.clickTime[btn] = clickTime;
        return false;
      }
    } else {
      osg.clickTime[btn] = clickTime;
      return false;
    }
  },
  /**
   * 中间号
   */
  getPrivateNumber(type, callerId, calleeId, sid) {
    window.$this.privateNumber = window.$this.privateNumber || {};
    window.$this.privateNumber.phone = '查询中';
    osg.ajax(
      '/basic/winnerlook/getMiddleNumber.do',
      {
        type: type || '1',
        callerId: callerId || JSON.parse(sessionStorage['loginAccount'])._id,
        calleeId,
        sid
      },
      res => {
        window.$this.privateNumber = window.$this.privateNumber || {};
        window.$this.privateNumber.phone = res.data.phoneNumberX;
      },
      { noload: true }
    );
  },
  /**
   * 解绑中间号
   */
  unBindPrivateNumber() {
    osg.ajax('/basic/winnerlook/handleMiddleNumberSelfUnBind.do');
  },
  //获取地理编码
  async getGeocode(that, formDataName) {
    that = that || window.$this;
    formDataName = formDataName || 'formData';
    if (that[formDataName].area[0] && that[formDataName].area[1]) {
      var citys = await that.$util.getCity(that[formDataName].area[0]);
      var cityName = '';
      for (var city of citys) {
        if (city._id == that[formDataName].area[1]) {
          cityName = city.name;
          break;
        }
      }
      that.osg.geocode(cityName + that[formDataName].address, res => {
        that[formDataName].gpsPoint = {
          longitude: res.location.split(',')[0],
          latitude: res.location.split(',')[1]
        };
        that.$forceUpdate();
      });
    }
  },
  /**
   * 当前租户下角色 当前角色
   */
  roles: [],
  currentRole: {},
  /**
   * 复制内容至剪切板
   */
  doCopy(text, msg) {
    window.$this.$copyText(text).then(
      function() {
        osg.toast(msg || '复制成功');
      },
      function() {
        osg.toast('复制失败，请稍后重试。');
      }
    );
  },
  /**
   * 保留两位小数
   */
  amountFilter(value) {
    if (!Number(value)) value = 0;
    return Number(value).toLocaleString('en-us', {
      maximumFractionDigits: 2, // 小数位最大保留位数：0-20
      minimumFractionDigits: 2 // 小数位最小保留位数：0-20
    });
  },
  // 字段展示权限
  showType(field, formData, currentRoleId) {
    // 兼容旧版frontEndConfig配置
    if (field.frontEndConfig.showField) {
      let showField = field.frontEndConfig.showField;
      let showValue = field.frontEndConfig.showValue;
      if (showValue == '$exist') {
        if (showField.indexOf('.') != -1) {
          let key = showField.split('.')[0];
          let subkey = showField.split('.')[1];
          if (formData[key] && formData[key][subkey]) {
            if (Array.isArray(formData[key][subkey])) {
              if (formData[key][subkey].length > 0) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          if (formData[showField]) {
            if (Array.isArray(formData[showField])) {
              if (formData[showField].length > 0) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
      } else {
        if (showField.indexOf('.') != -1) {
          let key = showField.split('.')[0];
          let subkey = showField.split('.')[1];
          if (formData[key] && formData[key][subkey]) {
            if (Array.isArray(formData[key][subkey])) {
              if (formData[key][subkey].indexOf(showValue) != -1) {
                return true;
              } else {
                return false;
              }
            } else {
              if (formData[key][subkey] == showValue) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        } else {
          if (formData[showField] || formData[showField] === 0) {
            if (Array.isArray(formData[showField])) {
              if (Array.isArray(showValue)) {
                for (let i = 0; i < showValue.length; i++) {
                  if (formData[showField].indexOf(showValue[i]) != -1) {
                    return true;
                  }
                }
                return false;
              } else {
                if (formData[showField].indexOf(showValue) != -1) {
                  console.log(formData[showField], showValue);
                  return true;
                } else {
                  return false;
                }
              }
            } else {
              if (Array.isArray(showValue)) {
                if (showValue.indexOf(formData[showField]) != -1) {
                  return true;
                } else {
                  return false;
                }
              } else {
                if (formData[showField] == showValue) {
                  return true;
                } else {
                  return false;
                }
              }
            }
          } else {
            return false;
          }
        }
      }
    } else if (field.showType != '1') {
      let showField = field.showField;
      let showFieldPreset = field.showFieldPreset;
      let showValue = field.showValue || field.exts.showValue;
      // 有值就展示
      if (field.showType == '2') {
        if (showFieldPreset) {
          if (formData[showField]) {
            if (Array.isArray(formData[showField])) {
              if (formData[showField].length > 0) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          if (formData.exts[showField]) {
            if (Array.isArray(formData.exts[showField])) {
              if (formData.exts[showField].length > 0) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
      }
      // 根据其他字段展示
      if (field.showType == '3') {
        if (showFieldPreset) {
          if (formData[showField]) {
            if (Array.isArray(formData[showField])) {
              if (Array.isArray(showValue)) {
                if (showValue.find(item => item.join() == formData[showField].join())) {
                  return true;
                } else {
                  return false;
                }
              } else {
                if (formData[showField].indexOf(showValue) != -1) {
                  return true;
                } else {
                  return false;
                }
              }
            } else {
              if (formData[showField] == showValue) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        } else {
          if (formData.exts[showField]) {
            if (Array.isArray(formData.exts[showField])) {
              if (formData.exts[showField].indexOf(showValue) != -1) {
                return true;
              } else {
                return false;
              }
            } else {
              if (formData.exts[showField] == showValue) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }
      }
      // 指定角色可见
      if (field.showType == '4') {
        if (field.roleIds.indexOf(currentRoleId) != -1) {
          return true;
        } else {
          return false;
        }
      }
      // 指定角色不可见
      if (field.showType == '5') {
        if (field.roleIds.indexOf(currentRoleId) == -1) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  },
  // 获取验证码图片
  getImageCaptcha(callback) {
    osg.ajax(
      '/i/imageCaptcha/generate.do',
      {},
      res => {
        //获取响应Jsessionid 并将token存到cookie
        let token = res.headers['jsessionid'];
        window.$this.$util.cookie.set(
          'JSESSIONID',
          token,
          window.$this.$util.cookieRelative.tokenExpires
        );

        let blob = new Blob([res.data]);
        let url = window.URL.createObjectURL(blob);
        if (callback) callback(url);
      },
      { responseType: 'blob', noload: true }
    );
  },
  // 租户配置
  tenantConfig: { exts: {} },
  /**
   * 省市区街道数据字典
   */
  // 级联
  areaList: [],
  // 分开
  areaObj: { province_list: {}, city_list: {}, county_list: {}, street_list: {} },
  // 视频格式
  videoFormat: [
    'mp4',
    '3gp',
    'm2v',
    'mkv',
    'rm',
    'rmvb',
    'wmv',
    'asf',
    'asx',
    'avi',
    'dat',
    'flv',
    'mov',
    'vob',
    'm4v'
  ],
  // 当前登录用户的可见行政区划
  myRegions: [],
  /**
   * show-overflow-tooltip换行
   */
  toBreak(val, breakSymbol) {
    if (!val) return;
    breakSymbol = breakSymbol || ',';
    if (Array.isArray(breakSymbol)) {
      breakSymbol.map(symbol => {
        // 将特殊符号转译
        val = val.replace(
          new RegExp(symbol.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'),
          symbol + '<br />'
        );
      });
      return val;
    } else {
      // 将特殊符号转译
      return val.replace(
        new RegExp(breakSymbol.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'),
        breakSymbol + '<br />'
      );
    }
  },
  // 展示属性变更记录
  openModify(smodule, sid) {
    let fieldsObj = {};
    window.$this.extFields.map(item => {
      if (item.showList && item.showList.indexOf('6') != -1) {
        item.label = item.nameDisp;
        item.value = item.name;
        fieldsObj[item.name] = item;
      }
    });
    window.$this.modify.fieldsObj = fieldsObj;

    osg.ajax(
      'biz/changeLog/query.do',
      {
        smodule: smodule || null,
        sid,
        _all: '1'
      },
      res => {
        if (res.data.length > 0) {
          // 不需要展示变更的字段名
          res.data = res.data.filter(item => {
            item.modifyList = item.modifyList.filter(obj => {
              return fieldsObj[obj.field] && fieldsObj[obj.field].showList.indexOf('6') != -1;
            });
            return item.modifyList.length > 0;
          });
          window.$this.modify.show = true;
          window.$this.modify.historyFpi = res;
        } else {
          osg.toast('没有属性变更记录');
          window.$this.modify.show = false;
          window.$this.modify.historyFpi = {
            page: 1,
            rows: 0,
            data: []
          };
        }
      },
      { noload: true }
    );
  }
};
export default {
  osg
};
